module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.b06871f2.ttf";